import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-411deb3b")

_pushScopeId("data-v-411deb3b")
const _hoisted_1 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString(`振り返り`))
const _hoisted_2 = { class: "w-full h-full relative" }
const _hoisted_3 = {
  key: 0,
  class: "reflection-wrapper"
}
const _hoisted_4 = { class: "mb-8" }
const _hoisted_5 = { class: "text-2xl font-bold mb-2" }
const _hoisted_6 = { class: "mb-4" }
const _hoisted_7 = { class: "text-xl mb-1" }
const _hoisted_8 = {
  key: 1,
  class: "flex items-center justify-center w-4/5 h-24 mx-auto bg-white rounded-lg text-base text-center text-gray-500"
}
const _hoisted_9 = { class: "mb-4" }
const _hoisted_10 = { class: "text-xl mb-1" }
const _hoisted_11 = { class: "flex flex-col w-4/5 mx-auto" }
const _hoisted_12 = { class: "border-collapse w-full" }
const _hoisted_13 = /*#__PURE__*/_createVNode("tr", { class: "bg-gray-300" }, [
  /*#__PURE__*/_createVNode("th", { class: "w-1/5 border font-medium border-gray-400 p-1" }, " 日付 "),
  /*#__PURE__*/_createVNode("th", { class: "w-4/5 border font-medium border-gray-400 p-1" }, " 内容 ")
], -1)
const _hoisted_14 = { class: "w-1/5 border border-gray-400 p-1" }
const _hoisted_15 = { class: "w-4/5 border border-gray-400 p-1 " }
const _hoisted_16 = { class: "w-full flex flex-row gap-1 items-center" }
const _hoisted_17 = { class: "block flex-1 break-all whitespace-normal" }
const _hoisted_18 = { class: "text-xl mb-1" }
const _hoisted_19 = { class: "flex flex-col w-4/5 mx-auto" }
const _hoisted_20 = { class: "border-collapse w-full" }
const _hoisted_21 = /*#__PURE__*/_createVNode("tr", { class: "bg-gray-300" }, [
  /*#__PURE__*/_createVNode("th", { class: "w-1/5 border font-medium border-gray-400 p-1" }, " 日付 "),
  /*#__PURE__*/_createVNode("th", { class: "w-4/5 border font-medium border-gray-400 p-1" }, " 内容 ")
], -1)
const _hoisted_22 = { class: "w-1/5 border border-gray-400 p-1" }
const _hoisted_23 = { class: "w-4/5 border border-gray-400 p-1 " }
const _hoisted_24 = { class: "w-full flex flex-row gap-1 items-center" }
const _hoisted_25 = { class: "block flex-1 break-all whitespace-normal" }
const _hoisted_26 = /*#__PURE__*/_createVNode("h1", { class: "text-2xl font-bold mb-2" }, /*#__PURE__*/_toDisplayString(`単元を通しての振り返り`), -1)
const _hoisted_27 = { class: "mb-4" }
const _hoisted_28 = /*#__PURE__*/_createVNode("h2", { class: "text-xl mb-1" }, "自身の振り返り", -1)
const _hoisted_29 = { class: "mb-4" }
const _hoisted_30 = /*#__PURE__*/_createVNode("h2", { class: "text-xl mb-1" }, "先生からの振り返り", -1)
const _hoisted_31 = { class: "pb-4" }
const _hoisted_32 = /*#__PURE__*/_createVNode("h2", { class: "text-xl mb-1" }, "AIの振り返り", -1)
const _hoisted_33 = {
  key: 1,
  class: "reflection-wrapper"
}
const _hoisted_34 = { class: "font-medium text-2xl text-center mb-8" }
const _hoisted_35 = { class: "w-4/5 mx-auto flex flex-row items-center" }
const _hoisted_36 = /*#__PURE__*/_createVNode("h2", { class: "font-normal text-lg w-32" }, "振り返り", -1)
const _hoisted_37 = {
  key: 2,
  class: "reflection-wrapper"
}
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { class: "text-xl mb-4" }
const _hoisted_40 = { key: 1 }
const _hoisted_41 = { key: 3 }
const _hoisted_42 = /*#__PURE__*/_createVNode("p", null, "問題が発生しました。画面をリロードしてやり直してみてください。", -1)
const _hoisted_43 = {
  key: 4,
  class: "buttons absolute flex flex-row top-0 right-0"
}
const _hoisted_44 = { key: 0 }
const _hoisted_45 = {
  key: 1,
  class: "flex flex-row gap-2"
}
const _hoisted_46 = /*#__PURE__*/_createTextVNode("キャンセル")
const _hoisted_47 = {
  key: 2,
  class: "flex flex-row gap-2"
}
const _hoisted_48 = /*#__PURE__*/_createTextVNode("戻る")
const _hoisted_49 = { key: 3 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_MSLineChart = _resolveComponent("MSLineChart")
  const _component_MIcon = _resolveComponent("MIcon")
  const _component_MTextArea = _resolveComponent("MTextArea")
  const _component_MButton = _resolveComponent("MButton")
  const _component_MBaseModal = _resolveComponent("MBaseModal")

  return (_openBlock(), _createBlock(_component_MBaseModal, {
    "body-background-color": "bg-primary-100",
    height: _ctx.status === 'display' ? 'tall' : 'normal',
    onClose: _ctx.close
  }, {
    title: _withId(() => [
      _hoisted_1
    ]),
    body: _withId(() => [
      _createVNode("main", _hoisted_2, [
        (_ctx.status === 'display')
          ? (_openBlock(), _createBlock("div", _hoisted_3, [
              _createVNode("section", _hoisted_4, [
                _createVNode("h1", _hoisted_5, _toDisplayString(`${_ctx.unitName}の内容`), 1),
                _createVNode("div", _hoisted_6, [
                  _createVNode("h2", _hoisted_7, _toDisplayString(`${_ctx.graphTitle}`), 1),
                  (_ctx.reflections.length > 0)
                    ? (_openBlock(), _createBlock(_component_MSLineChart, {
                        key: 0,
                        class: "line-chart-canvas",
                        labels: _ctx.labels,
                        datasets: _ctx.datasets,
                        min: _ctx.min,
                        max: _ctx.max
                      }, null, 8, ["labels", "datasets", "min", "max"]))
                    : (_openBlock(), _createBlock("div", _hoisted_8, " 表示するデータがありません。 "))
                ]),
                _createVNode("div", _hoisted_9, [
                  _createVNode("h2", _hoisted_10, _toDisplayString(`${_ctx.secondRowTitle}`), 1),
                  _createVNode("div", _hoisted_11, [
                    _createVNode("table", _hoisted_12, [
                      _hoisted_13,
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.reflections, (r, i) => {
                        return (_openBlock(), _createBlock("tr", {
                          key: i,
                          class: "bg-white"
                        }, [
                          _createVNode("td", _hoisted_14, _toDisplayString(_ctx.formatDate(r.data.uid)), 1),
                          _createVNode("td", _hoisted_15, [
                            _createVNode("div", _hoisted_16, [
                              _createVNode("span", _hoisted_17, _toDisplayString(r.data.reflection), 1),
                              (_ctx.studentHasPolarDevice)
                                ? (_openBlock(), _createBlock(_component_MIcon, {
                                    key: 0,
                                    type: "heart",
                                    class: "text-gray-500 mr-1 cursor-pointer",
                                    onClick: ($event: any) => (_ctx.openHeartRateData(r.data.uid))
                                  }, null, 8, ["onClick"]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ]),
                _createVNode("div", null, [
                  _createVNode("h2", _hoisted_18, _toDisplayString(`${_ctx.thirdRowTitle}`), 1),
                  _createVNode("div", _hoisted_19, [
                    _createVNode("table", _hoisted_20, [
                      _hoisted_21,
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.reflections, (r, i) => {
                        return (_openBlock(), _createBlock("tr", {
                          key: i,
                          class: "bg-white"
                        }, [
                          _createVNode("td", _hoisted_22, _toDisplayString(_ctx.formatDate(r.data.uid)), 1),
                          _createVNode("td", _hoisted_23, [
                            _createVNode("div", _hoisted_24, [
                              _createVNode("span", _hoisted_25, _toDisplayString(r.data.description), 1),
                              (_ctx.studentHasPolarDevice)
                                ? (_openBlock(), _createBlock(_component_MIcon, {
                                    key: 0,
                                    type: "heart",
                                    class: "text-gray-500 mr-1 cursor-pointer",
                                    onClick: ($event: any) => (_ctx.openHeartRateData(r.data.uid))
                                  }, null, 8, ["onClick"]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ]),
              _createVNode("section", null, [
                _hoisted_26,
                _createVNode("div", _hoisted_27, [
                  _hoisted_28,
                  _createVNode("div", {
                    class: ["w-4/5 mx-auto bg-white p-2 break-all whitespace-pre-line", { 'text-gray-500': !_ctx.unit || !_ctx.unit.data.selfReflection }]
                  }, _toDisplayString(_ctx.unit?.data.selfReflection || "まだコメントがありません。"), 3)
                ]),
                _createVNode("div", _hoisted_29, [
                  _hoisted_30,
                  _createVNode("div", {
                    class: ["w-4/5 mx-auto bg-white p-2 break-all whitespace-pre-line", {
                  'text-gray-500': !_ctx.unit || !_ctx.unit.data.teacherReflection
                }]
                  }, _toDisplayString(_ctx.unit?.data.teacherReflection || "まだコメントがありません。"), 3)
                ]),
                _createVNode("div", _hoisted_31, [
                  _hoisted_32,
                  _createVNode("div", {
                    class: ["w-4/5 mx-auto bg-white p-2 break-all whitespace-pre-line", {
                  'text-gray-500': !_ctx.unit || !_ctx.unit.data.aiReflection
                }]
                  }, _toDisplayString(_ctx.unit?.data.aiReflection || "まだコメントがありません。"), 3)
                ])
              ])
            ]))
          : (_ctx.status === 'teacherReflectionInput')
            ? (_openBlock(), _createBlock("div", _hoisted_33, [
                _createVNode("h1", _hoisted_34, _toDisplayString(`${_ctx.unitName}先生振り返り登録`), 1),
                _createVNode("div", _hoisted_35, [
                  _hoisted_36,
                  _createVNode(_component_MTextArea, {
                    value: _ctx.unitReflection,
                    height: "tall",
                    "background-color": "white",
                    onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.unitReflection = $event)),
                    onEnter: _cache[2] || (_cache[2] = 
                () => {
                  if (!_ctx.isTeacherReflectionEmpty) {
                    _ctx.validUnitReflection = true;
                  } else {
                    if (_ctx.unitReflection.length > 0) {
                      _ctx.validUnitReflection = true;
                    } else {
                      _ctx.validUnitReflection = false;
                    }
                  }
                }
              )
                  }, null, 8, ["value"])
                ])
              ]))
            : (_ctx.status === 'heartRate')
              ? (_openBlock(), _createBlock("div", _hoisted_37, [
                  (_ctx.targetHeartRateData.length > 0)
                    ? (_openBlock(), _createBlock("div", _hoisted_38, [
                        _createVNode("h2", _hoisted_39, _toDisplayString(_ctx.heartRateTitle), 1),
                        (_ctx.reflections.length > 0)
                          ? (_openBlock(), _createBlock(_component_MSLineChart, {
                              key: 0,
                              class: "line-chart-canvas",
                              labels: _ctx.targetHeartRatesLabels,
                              datasets: _ctx.targetHeartRatesDatasets,
                              min: _ctx.targetHeartRatesMin,
                              max: _ctx.targetHeartRatesMax
                            }, null, 8, ["labels", "datasets", "min", "max"]))
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_40, " 該当の時間にデータはありません。 "))
                ]))
              : (_openBlock(), _createBlock("div", _hoisted_41, [
                  _hoisted_42
                ])),
        (_ctx.status === 'display')
          ? (_openBlock(), _createBlock("div", _hoisted_43, [
              _createVNode(_component_MButton, { onClick: _ctx.openReflectionInput }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(`振り返りを${_ctx.isTeacherReflectionEmpty ? "登録" : "更新"}`), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    footer: _withId(() => [
      (_ctx.status === 'display')
        ? (_openBlock(), _createBlock("div", _hoisted_44))
        : (_ctx.status === 'teacherReflectionInput')
          ? (_openBlock(), _createBlock("div", _hoisted_45, [
              _createVNode(_component_MButton, {
                outline: "",
                onClick: _ctx.clearUnitReflectionInput
              }, {
                default: _withId(() => [
                  _hoisted_46
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_MButton, {
                disabled: !_ctx.validUnitReflection,
                onClick: _ctx.registerUnitReflection
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.isTeacherReflectionEmpty ? "登録" : "更新"), 1)
                ]),
                _: 1
              }, 8, ["disabled", "onClick"])
            ]))
          : (_ctx.status === 'heartRate')
            ? (_openBlock(), _createBlock("div", _hoisted_47, [
                _createVNode(_component_MButton, {
                  outline: "",
                  onClick: _ctx.clearHeartRateData
                }, {
                  default: _withId(() => [
                    _hoisted_48
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_49))
    ]),
    _: 1
  }, 8, ["height", "onClose"]))
})